//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */

const home = () => import("../components/home.vue");
const addedit = () => import("../components/add_edit.vue");
const subscribe = () => import("../components/subscribe.vue");
const invite = () => import("../components/invite.vue");

const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  { name: "home", path: "/", component: home, display: "Home", icon: "Home" },
  {
    name: "addedit",
    path: "/addedit",
    component: addedit,
    display: "addedit",
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: subscribe,
    display: "subscribe",
  },
  {
    name: "invite",
    path: "/invite",
    component: invite,
    display: "invite",
  },

  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
